import {FRONTEND_VERSION_API} from "@/contants/api";

export default $axios => ({
  getAddressByZipCode(payload) {
    return $axios.get(`${FRONTEND_VERSION_API}/get-address-by-postcode/${payload}`);
  }
})
